export const DATE_FORMAT = 'dd/MM/yyyy'
export const TIME_FORMAT = 'HH:mm'
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm'
export const DATE_TIME_OFFSET_FORMAT = 'dd/MM/yyyy HH:mm z'
export const DATE_ABBREVIATED_FORMAT = 'E dd MMM yy'
export const DATE_TIME_SECONDS_FORMAT = 'dd/MM/yyyy HH:mm:ss'
